import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; // Import Router
import { CartService } from '../../services/cart.service';
import { Order } from 'src/app/models/order.model';

declare var fbq: any;

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.css']
})
export class OrderConfirmationComponent implements OnInit {
  orderId: string | null = null;
  orderDetails: Order | null = null;
  isLoading: boolean = true;
  hasError: boolean = false;
  errorMessage: string = '';
  private readonly ORDER_CONFIRMED_KEY = 'orderConfirmed_';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cartService: CartService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.orderId = params.get('orderId');

      if (!this.orderId) {
        this.handleErrorAndRedirect('No Order ID provided for confirmation.', true);
        return;
      }

      const storageKey = this.ORDER_CONFIRMED_KEY + this.orderId;

      if (sessionStorage.getItem(storageKey) === 'true') {
        this.handleErrorAndRedirect('Order confirmation already viewed.', true);
        return;
      }
      this.isLoading = true;
      this.hasError = false;
      this.errorMessage = '';

      this.cartService.getOrderDetails(this.orderId).subscribe({
        next: (response) => {
          if (response.success && response.order_details) {
            this.orderDetails = response.order_details;
                        this.trackPurchase();
            sessionStorage.setItem(storageKey, 'true');
            this.isLoading = false;
          } else {
            const message = response.message || 'Failed to load order details.';
            this.handleErrorAndRedirect(message, true);
          }
        },
        error: (err) => {
          const message = 'An error occurred while fetching order details. Please try again.';
          this.handleErrorAndRedirect(message, true);
        }
      });
    });
  }
  private trackPurchase(): void {
    if (!this.orderDetails || typeof fbq === 'undefined') return;

    const contents = this.orderDetails.order_items.map((item: any) => ({
      id: item.product_id || item.id || item.product_name,
      quantity: Number(item.quantity),
      item_price: Number(item.price_at_order)
    }));

    const contentNames = this.orderDetails.order_items.map((item: any) => item.product_name);

    fbq('track', 'Purchase', {
      value: Number(this.orderDetails.final_total),
      currency: 'INR',
      content_type: 'product',
      content_name: contentNames.join(', '),
      contents: contents,
      num_items: this.orderDetails.order_items.reduce((sum: number, item: any) => sum + Number(item.quantity), 0)
    });
  }

  private handleErrorAndRedirect(message: string, redirect: boolean): void {
    this.hasError = true;
    this.errorMessage = message;
    this.isLoading = false;

    if (redirect) {
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 100);
    }
  }
}